import React from 'react';
import VirtualizedSelect from 'react-virtualized-select';
// import cx from 'classnames';

import styles from './PhoneInput.css';
import phone from '../../shared/phone.json';

const phoneOptions = phone.map(item => ({
  label: `${item[1]} (+${item[2]})`,
  value: item[2],
}));

export default function PhoneInput(props) {
  let code = '33';
  let number = '';

  if (props.value) {
    const match = props.value.match(/\+([0-9]+) (.*)/);
    if (match) {
      code = match[1];
      number = match[2];
    }
  }

  function onCodeChange(newOpt) {
    props.onChange(`+${newOpt.value} ${number}`);
  }

  function onNumberChange(e) {
    if (e.target.value === '') {
      props.onChange('');
      return;
    }
    props.onChange(`+${code} ${e.target.value}`);
  }

  return (
    <div className={styles.phoneInput}>
      <VirtualizedSelect
        options={phoneOptions}
        value={code}
        onChange={onCodeChange}
        clearable={false}
      />

      <input
        {...props}
        value={number}
        onChange={onNumberChange}
      />
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/PhoneInput.js
 **/